module.exports = __webpack_public_path__ + "static/media/minus.00e1745b.svg";